<aside [ngClass]="{'translate-x-0': mobileMenuOpen, '-translate-x-full': !mobileMenuOpen }" class="fixed top-0 left-0 w-64 bg-white dark:bg-[#181C2A] p-4 flex flex-col justify-between h-full z-50 mt-[65px] transition-transform duration-300 md:translate-x-0">
  <div>
    <nav class="flex flex-col gap-2">

      <!-- Dashboard -->
      <a routerLink="/dashboard" routerLinkActive="bg-primary/10 dark:bg-primary/20 text-primary"
         class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors">
        <span class="material-symbols-outlined">home</span>
        <p class="text-sm font-medium">Dashboard</p>
      </a>

      <!-- Projects Dropdown -->
      <div class="group">
        <a (click)="toggleProjects()"
           class="flex items-center justify-between gap-3 px-3 py-2.5 rounded-lg cursor-pointer"
           [ngClass]="{
             'bg-primary/10 dark:bg-primary/20 text-primary': isProductActive,
             'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700/50': !isProductActive
           }">
          <div class="flex items-center gap-3">
            <span class="material-symbols-outlined">widgets</span>
            <p class="text-sm font-medium">Projects</p>
          </div>
          <span class="material-symbols-outlined transition-transform"
                [class.rotate-90]="isProductActive">chevron_right</span>
        </a>

        <div *ngIf="isProductActive" class="ml-7 mt-1 border-l border-gray-200 dark:border-gray-700 pl-2 space-y-1">
          <a *ngFor="let module of modules"
             [routerLink]="['/content', module.route]"
             [ngClass]="{
               'bg-secondary/10 dark:bg-secondary/20 text-secondary': isModuleActive(module),
               'block px-3 py-1.5 text-sm rounded-md text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-white': true
             }">
            {{ module.name }}
          </a>
        </div>
      </div>

      <!-- Masters -->
      <a routerLink="/masters" routerLinkActive="bg-primary/10 dark:bg-primary/20 text-primary"
         class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors">
        <span class="material-symbols-outlined">home</span>
        <p class="text-sm font-medium">Masters</p>
      </a>

      <!-- Upload -->
      <a routerLink="/upload" routerLinkActive="bg-primary/10 dark:bg-primary/20 text-primary"
         class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors">
        <span class="material-symbols-outlined">upload</span>
        <p class="text-sm font-medium">Upload</p>
      </a>

      <!-- Users Sync -->
       <a routerLink="/users-sync" routerLinkActive="bg-primary/10 dark:bg-primary/20 text-primary"
        class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors">
        <span class="material-symbols-outlined">sync</span>
        <p class="text-sm font-medium">Users Sync</p>
      </a>

    </nav>
  </div>
</aside>
